import removeFilter from '@/useCases/filters/removeFilter'
import { IParamsByUrl } from '~types/search'

const removeFilterByValue = ({
  urlParams,
  filterValue,
  type,
}: {
  urlParams: IParamsByUrl
  filterValue?: string | null
  type?: string | null
}) => {
  console.log('🚀 ~ type:', type)
  console.log('🚀 ~ filterValue:', filterValue)
  console.log('🚀 ~ urlParams:', urlParams)
  const newParams = removeFilter(urlParams, filterValue || '', type || '')
  console.log('🚀 ~ newParams:', newParams)
  return newParams
}

export default removeFilterByValue
